/**
 * apps/web :: pages :: SupportPage
 *
 * Placeholder learner-portal surface for in-app Support (ROADS nav
 * restructure). Renders inside `<LearnerPortalShell>` like the other
 * informational learner pages. No backend calls yet — the support-center
 * pipeline lands in a later ticket.
 */
import { useTranslation } from "react-i18next";

import LearnerPortalShell from "@/components/learner/LearnerPortalShell";

export default function SupportPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <LearnerPortalShell pageTitle={t("support.title")}>
      <section className="mx-auto w-full max-w-3xl px-md pt-xl pb-xl sm:px-lg sm:pt-2xl sm:pb-2xl">
        <h1
          data-testid="support-heading"
          className="font-display text-2xl font-bold text-brand-primary sm:text-3xl"
        >
          {t("support.title")}
        </h1>
        <p className="mt-md text-neutral-700 sm:text-lg">{t("support.body")}</p>
      </section>
    </LearnerPortalShell>
  );
}
